var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-media', {
    attrs: {
      "tag": "li"
    },
    scopedSlots: _vm._u([{
      key: "aside",
      fn: function () {
        return [_c('div', {
          staticClass: "img-box"
        }, [_c('b-img', {
          attrs: {
            "src": _vm.itemData.imageLink || _vm.itemData.custom.shopImage,
            "width": "50",
            "height": "50",
            "alt": "placeholder"
          }
        })], 1)];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "orderItmeDetailsSec"
  }, [_c('div', {
    staticClass: "item-qty"
  }, [_c('h6', {
    staticClass: "mt-0 mb-3 text-left"
  }, [_vm._v(" " + _vm._s(_vm.itemData.name || _vm.itemData.providerName) + " ")])]), _c('div', {
    staticClass: "price-details"
  }, [_c('div', {
    staticClass: "d-flex deal-price align-items-center mb-2"
  }, [_c('h6', {}, [_vm._v(" " + _vm._s(_vm.currency.symbol) + " " + _vm._s(_vm.itemData.price.toFixed(2)) + " ")]), _vm.itemData.unitDiscountedPrice ? _c('del', {
    staticClass: "text-icon mb-0 ml-3"
  }, [_vm._v(" " + _vm._s(_vm.currency.symbol) + " " + _vm._s((_vm.itemData.unitPrice * _vm.itemData.qty).toFixed(2)) + " ")]) : _vm._e()]), _c('div', [_vm.itemData.discount > 0 ? _c('h6', {
    staticClass: "discount-rate"
  }, [_vm._v(" " + _vm._s(_vm.currency.symbol) + " " + _vm._s((_vm.itemData.discount * _vm.itemData.qty).toFixed(2)) + " Off ")]) : _vm._e()])]), _c('p', {
    staticClass: "text-top"
  }, [_vm._v("Quantity: " + _vm._s(_vm.itemData.qty))]), _c('p', {
    staticClass: "text-icon mb-0 itemPricePara"
  }, [_vm._v(" " + _vm._s(_vm.currency.symbol) + " " + _vm._s(_vm.itemData.price.toFixed(2)) + " ")])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }